import * as React from 'react';
import { useState, useEffect, withHooks } from 'blx-react-hooks';
import { RouteComponentProps } from 'react-router-dom';
import { apiForDomain } from '@weike/services';
import { WKLoading } from '@components/WK/WKLoading';

interface IDomainCheckState {
  isLoading: boolean;
  shouldRender: boolean;
}

/**
 * HOC组件：处理apiForDomain逻辑
 * 如果domain.redirected为true则不渲染组件
 * 否则正常渲染组件并保持所有props
 */
export function withDomainCheck<P extends object>(WrappedComponent: React.ComponentType<P>) {
  // 创建内部组件，使用withHooks包装
  const WithDomainCheckOutter = withHooks(function WithDomainCheckInner(
    props: P & RouteComponentProps<{ liveroomId: string }>
  ) {
    const [state, setState] = useState<IDomainCheckState>({
      isLoading: true,
      shouldRender: false
    });

    useEffect(() => {
      const checkDomain = async () => {
        const { liveroomId } = props.match.params;
        if (!liveroomId || isNaN(+liveroomId)) {
          // 如果没有有效的liveroomId，直接渲染
          setState({ isLoading: false, shouldRender: true });
          return;
        }

        try {
          const env = process.env.REACT_APP_RUNTIME as Parameters<typeof apiForDomain>[0]['env'];

          const domain = await apiForDomain({
            target: 'liveroom',
            target_id: liveroomId,
            env
          });

          // 如果已被重定向，就不渲染组件
          if (domain.redirected) {
            setState({ isLoading: false, shouldRender: false });
            return;
          }

          // 正常渲染
          setState({ isLoading: false, shouldRender: true });
        } catch (error) {
          // 出错时也正常渲染，避免阻塞用户
          setState({ isLoading: false, shouldRender: true });
        }
      };

      checkDomain();
    }, [props.match.params.liveroomId]);

    // 加载中显示loading
    if (state.isLoading) {
      return <WKLoading />;
    }

    // 如果需要重定向，不渲染组件
    if (!state.shouldRender) {
      return null;
    }

    // 正常渲染组件，传递所有props（除了RouteComponentProps）
    // const { match, location, history, staticContext, ...restProps } = props;
    return <WrappedComponent {...(props as P)} />;
  });

  // 设置displayName便于调试
  WithDomainCheckOutter.displayName = `withDomainCheck(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return WithDomainCheckOutter;
}



// WEBPACK FOOTER //
// ./src/components/with-domain-check.tsx